import { useCallback, useEffect, useRef } from "react";
import { useLocation } from "wouter";
import { track, type TrackEventName, type TrackPayload } from "@/lib/tracking";
import { captureAttribution } from "@/lib/utm";

let attributionCaptured = false;

export function useTracking() {
  const [location] = useLocation();
  const lastTrackedPath = useRef<string | null>(null);

  // Captura UTMs uma única vez no primeiro mount
  useEffect(() => {
    if (!attributionCaptured) {
      captureAttribution();
      attributionCaptured = true;
    }
  }, []);

  // Dispara page_view em cada mudança de rota
  useEffect(() => {
    if (lastTrackedPath.current === location) return;
    lastTrackedPath.current = location;
    track("page_view", { path: location });
  }, [location]);

  const send = useCallback(
    (event: TrackEventName, payload: TrackPayload = {}) =>
      track(event, payload),
    []
  );

  return { track: send };
}
